module.exports = __webpack_public_path__ + "icon-detailed-records.svg?e3d9caa9df26426d598106f7f7289625";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-detailed-records.svg
// module id = 36
// module chunks = 0